import { toast } from './ui'

interface OpComponent {
  busy: boolean;
}

export async function remoteOp(comp: OpComponent|null, verb: string, noun:string, f: ()=>Promise<void>, msgDelay?: number) {
  if (comp) {
    comp.busy = true
  }
  let t = toast('wait', '正在' + verb + noun)
  try {
    await f()
    if (comp) {
      comp.busy = false
    }
    t.set('success', noun + verb + '成功').close(msgDelay)
  }
  catch (e) {
    if (comp) {
      comp.busy = false
    }
    let detail = (e as Error).message
    t.set('error', noun + verb + '失败', detail).close('manual')
  }
}
